import { validate as isUuid } from 'uuid'
import { compact } from 'lodash'
import { type AppraiserAssignment } from 'ComponentLibrary/src/common/users'
import type { AccountDisplayData, UserPresentation } from 'ComponentLibrary/src/common/userPresentations'

const ASSIGNMENT_RANKS = ['main', 'secondary', 'tertiary'] as const

export function resolveAppraiserAssignment({
    assignment,
    users,
    organizationName,
}: {
    assignment?: AppraiserAssignment
    users: AccountDisplayData[]
    organizationName?: string
}): UserPresentation[] {
    if (!assignment) {
        return []
    }

    return compact(
        ASSIGNMENT_RANKS.map((rank): UserPresentation | undefined => {
            const value = assignment[rank]
            if (!value) {
                return undefined
            }

            const key = `appraiser:${rank}:${value}`

            if (isUuid(value)) {
                const resolvedUser = users.find((user) => user.uuid === value)
                return resolvedUser ? { kind: 'account', key, displayData: resolvedUser } : { kind: 'unavailable', key }
            }

            return {
                kind: 'nonUser',
                key,
                displayData: {
                    first_name: value,
                    organization_name: organizationName,
                },
            }
        })
    )
}
